import { RouteSeoMap, SeoMetadata } from './types.ts'

export const DEFAULT_SITE_URL = 'https://botnexus.ai'
export const EDGE_BYPASS_PARAM = 'edge-bypass'

export const DEFAULT_SEO: SeoMetadata = {
  title: 'BotNexus | Unified AI Agent Operations',
  description: 'Launch AI voice agents, orchestrate automations, and measure performance from one secure workspace.',
  image: '/logo.png',
  ogType: 'website',
  twitterCard: 'summary_large_image',
  locale: 'en_US',
}

export const ROUTE_SEO: RouteSeoMap = {
  '/': {
    title: 'BotNexus | Your AI Assistants',
    description: 'Access the assistants and workspaces available to you through BotNexus. Sign in, explore connected experiences, and learn how to get access.',
  },
}

export interface SeoResolutionOptions {
  baseUrl?: string
}

export const normalizePath = (pathname: string) => {
  if (!pathname) return '/'
  const cleaned = pathname.trim().split('?')[0].split('#')[0]
  if (cleaned === '' || cleaned === '/') return '/'
  return cleaned.endsWith('/') ? cleaned.slice(0, -1) : cleaned
}

const buildAbsoluteUrl = (value: string, baseUrl: string) => {
  if (!value) return baseUrl
  if (value.startsWith('http://') || value.startsWith('https://')) {
    return value
  }
  try {
    return new URL(value, baseUrl).toString()
  } catch {
    return `${baseUrl.replace(/\/$/, '')}${value.startsWith('/') ? value : `/${value}`}`
  }
}

const buildCanonicalUrl = (baseUrl: string, pathname: string) => {
  try {
    return new URL(pathname || '/', baseUrl).toString()
  } catch {
    return `${baseUrl.replace(/\/$/, '')}${pathname.startsWith('/') ? pathname : `/${pathname}`}`
  }
}

export const getSeoForPath = (
  pathname: string,
  options: SeoResolutionOptions = {}
): SeoMetadata => {
  const baseUrl = options.baseUrl || DEFAULT_SITE_URL
  const normalizedPath = normalizePath(pathname)
  const overrides = ROUTE_SEO[normalizedPath] || {}
  const metadata = { ...DEFAULT_SEO, ...overrides }

  return {
    ...metadata,
    canonicalUrl: buildCanonicalUrl(baseUrl, normalizedPath === '/' ? '/' : normalizedPath),
    image: buildAbsoluteUrl(metadata.image, baseUrl),
  }
}
